import type { InvoiceData, LineItemDetails, Supplier } from "@/apis/gql/types";

export enum SpecialFilterValue {
  Unknown = "unknown",
}

export type QueryResponse = {
  invoice: InvoiceData;
  supplier: Supplier;
  lineItemDetails: LineItemDetails[];
};
